import Image from 'next/image';
import styles from './style.module.css';
export default function ProductDisplayImage(props: {
  src: string;
  alt?: string;
}) {
  const {src, alt} = props;
  return (
    <div className={styles.productDisplayImageContainer}>
      {src && (
        <Image
          alt={alt || 'Product image'}
          src={src}
          fill
          sizes="(max-width: 768px) 100vw, 50vw"
          //width={550}
          //height={600}
        />
      )}
    </div>
  );
}
